import { gql } from "@urql/core";

import { query } from "@/services/lukita";

export default function accountsQuery() {
  return query(
    gql`
      query AccountsQuery {
        accounts {
          __typename
          id
          name
          active
          createdAt
        }
      }
    `,
    { additionalTypenames: ["AccountRecord"] },
  );
}
